import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { T } from "react-translator-component";
import PostCard from "../../components/lists/PostCard";
import LoadingModal from "../../components/LoadingModal";
import LoadMoreButton from "../../components/LoadMoreButton";
import { Stack, Typography } from "@mui/material";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import appServices from "../../services/app-services/appServices";

export default function PostHistory() {
  const navigate = useNavigate();
  const { user } = useSelector((state: any) => state.userAuth);
  const [privatePosts, setPrivatePosts] = useState<any>([]);
  const [pagination, setPagination] = useState<any>({});

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user?.id) apiCalls(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const apiCalls = async (page: number) => {
    if (!page) return

    setLoading(true);
    try {
      const posts = await appServices.getPrivatePostHistory(page);
      const newItems = [...privatePosts, ...posts.posts];
      setPrivatePosts(newItems);
      setPagination(posts.pagination);
    } catch (error: any) {
      // pass
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div style={{ height: "100px" }}></div>
      <div style={{ marginLeft: 8 }} onClick={() => navigate(-1)}>
        <ArrowBackIosIcon />
      </div>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={"center"}
        spacing={2}
      >
        <DriveFileRenameOutlineIcon />
        <Typography>{T("private_post")}</Typography>
      </Stack>
      <div
        style={{
          width: "95%",
          height: 3,
          backgroundColor: "black",
          margin: 4,
        }}
      ></div>
      <LoadingModal visible={loading} />

      {privatePosts?.map((item: any, index: number) => (
        <PostCard
          post={item}
          showStatus
          key={index}
        />
      ))}

      <LoadMoreButton show={pagination?.next_page > 0} onClick={() => apiCalls(pagination?.next_page)} />
    </div>
  );
}
